import * as _4 from 'lodash4';
import * as moment from 'moment';
import { AppointmentsAvailableTimesDatasource } from '../datasources/appointments_available_times_datasource';
import { UpcomingAppointmentsDatasource } from '../datasources/upcoming_appointments_datasource';
import { ConfirmAppointmentModel } from '../models/confirm_appointment_model';
import { IAvailableTime, INativeTimeSlot } from '../types/appointment_interfaces';
import { TAppointmentAvailableTimesUsersource } from '../usersources/appointment_available_times_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';
import { AppointmentsCommandServant } from './appointments_command_servant';

export interface ISelectedStaff {
  id: number;
  first_name: string;
  last_name: string;
}
export interface ISelectedTimeSlot {
  startTime: number;
  endTime: number;
  additionalDetails: string;
}

export interface IAppointmentsConfirmData {
  organizer_id: number;
  start_time: string;
  end_time: string;
  group_appointment_id?: number;
  student_service_id?: number;
  course_id?: number | null;
  location_id: number;
  appointment_type_id: number;
  send_email_reminder: boolean;
  send_sms_reminder: boolean;
  comments: string;
  student_mobile_number: string;
}

export interface IAppointmentsConfirmDataOptional {
  group_appointment_id: number;
  student_service_id?: number;
}

export class AppointmentsconfirmServant {
  constructor(
    private ngAppointmentsAvailableTimesDatasource: AppointmentsAvailableTimesDatasource,
    private ngAppointmentAvailableTimesUsersource: TAppointmentAvailableTimesUsersource,
    private ngUpcomingAppointmentsDatasource: UpcomingAppointmentsDatasource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private ngConfirmAppointmentModel: ConfirmAppointmentModel,
    private appointmentCampaignConstant: any,
    private ngAppointmentsCommandServant: AppointmentsCommandServant
  ) {}

  get appointmentInvitationConfirmData() {
    const invitation_id = this.appointmentCampaignConstant.campaignInvitationId;
    const {
      organizer_id,
      start_time,
      end_time,
      comments,
      student_mobile_number,
      send_email_reminder,
      send_sms_reminder
    } = this.appointmentsConformationData;
    const organizer_slot = `${moment(start_time).unix()}_${moment(end_time).unix()}`;
    return {
      invitation_id,
      organizer_slot,
      organizer_id,
      comments,
      student_mobile_number,
      send_email_reminder,
      send_sms_reminder
    };
  }

  get appointmentsConformationData(): IAppointmentsConfirmData {
    const selectedTimeDetails: IAvailableTime = this.ngAppointmentAvailableTimesUsersource.read().selectedTimeDetails;
    const organizer_id = selectedTimeDetails.available.id;
    const start_time = selectedTimeDetails.begin_time;
    const end_time = selectedTimeDetails.end_time;
    const group_appointment_id = selectedTimeDetails.group_appointment_id;
    const location_id = selectedTimeDetails.location_id;
    const appointment_type = this.ngAppointmentReasonUsersource.read().selectedType.id;
    const send_email_reminder = this.ngConfirmAppointmentModel.confirmAppointmentReminderOptions.isSendEmail;
    const send_sms_reminder = this.ngConfirmAppointmentModel.confirmAppointmentReminderOptions.isSendTextMessage;
    const comments = this.ngConfirmAppointmentModel.Comments;
    const student_mobile_number = this.ngConfirmAppointmentModel.phoneNumber;
    const serviceAndCourseData = this.ngAppointmentsCommandServant.getCourseOrServiceID();
    const data = {} as IAppointmentsConfirmDataOptional;
    if (group_appointment_id >= 0) {
      data.group_appointment_id = group_appointment_id;
    }

    return {
      organizer_id,
      start_time,
      end_time,
      location_id,
      send_email_reminder,
      send_sms_reminder,
      comments,
      student_mobile_number,
      ...data,
      ...serviceAndCourseData,
      appointment_type_id: appointment_type
    };
  }

  selectedStaff(): ISelectedStaff {
    const selectedTimeSlot: INativeTimeSlot = this.selectedTime();
    return {
      first_name: selectedTimeSlot.organizer.first_name,
      last_name: selectedTimeSlot.organizer.last_name,
      id: selectedTimeSlot.organizer.id
    };
  }

  selectedTime() {
    const availableTimes = this.ngAppointmentsAvailableTimesDatasource.read().availableTimes;
    const unixtime: number = moment(
      this.ngAppointmentsAvailableTimesDatasource.read().selectedTime.date,
      'YYYY-MM-DD hh:mm A'
    ).unix();
    return _4.find(availableTimes, { begin_time: unixtime });
  }

  selectedTimeSlot(): ISelectedTimeSlot {
    const timeObj: INativeTimeSlot = this.selectedTime();
    return {
      startTime: timeObj.begin_time,
      endTime: timeObj.end_time,
      additionalDetails: timeObj.additional_details
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointments_confirm_servant.ts